import styled from 'styled-components'

import { TitleSection as TitleSectionBase } from '@organisms/TitleSection'

export const TitleSection = styled(TitleSectionBase)`
    background: ${(props) => props.theme.color[props.mode === 'Light' ? 'g100' : 'p600']};
`
